module.exports = __webpack_public_path__ + "img/credit_03.ff2214c9.png";